/* Search-only presentation. Never mutate product objects, data-image or storage. */
(function () {
  'use strict';
  if (window.OddSearchImages) return;
  var config = document.getElementById('OddSearchImageConfig');
  if (!config) return;
  var products, imageConfig;
  try { imageConfig = JSON.parse(config.textContent); products = imageConfig.products; } catch (e) { return; }
  var saved = new WeakMap(), failures = new WeakMap();
  var labels = {csm: 'Chainsaw Man', jjk: 'Jujutsu Kaisen', mha: 'My Hero Academia', kny: 'Demon Slayer'};
  function clean(v) {
    return String(v || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[’']/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  var names = {
    csm: ['chainsaw man','csm','denji','makima','reze','raze','rese','pochita','aki hayakawa','kobeni higashiyama'],
    jjk: ['jujutsu kaisen','jujutsu','jjk','satoru gojo','gojo satoru','gojo','suguru geto','geto','ryomen sukuna','sukuna','yuji itadori','itadori','megumi fushiguro','nobara kugisaki','nobara','kento nanami','toji fushiguro','toge inumaki','yuta okkotsu','choso'],
    mha: ['my hero academia','boku no hero academia','mha','bnha','izuku midoriya','izuku','midoriya','deku','katsuki bakugo','katsuki bakugou','bakugo','bakugou','shoto todoroki','todoroki','ochaco uraraka','uraraka','shota aizawa','aizawa','eraser head','himiko toga'],
    kny: ['demon slayer','kimetsu no yaiba','kny','tanjiro kamado','tanjiro','nezuko kamado','nezuko','zenitsu agatsuma','zenitsu','inosuke hashibira','inosuke','shinobu kocho','giyu tomioka','giyuu tomioka','giyu','giyuu','kyojuro rengoku','rengoku','mitsuri kanroji','mitsuri','muichiro tokito','muichiro','tengen uzui','obanai iguro','sanemi shinazugawa','gyomei himejima','kanao tsuyuri','genya shinazugawa']
  };
  // Only explicit franchise context may disambiguate these short names / common words.
  var ambiguous = {csm:['power','aki'], jjk:['megumi','yuta','nanami'], mha:['shoto','katsuki','toga'], kny:['shinobu','tengen','obanai','sanemi','gyomei','kanao','genya']};
  var generic = /\b(?:phone|phones|case|cases|cover|covers|headphone|headphones|earphone|earphones|earbuds|headset|audio|wireless|bluetooth|anc|custom|customizable|customisable|display|screen|dual|nfc|e|ink|smart|badge|pin|pins|crystal|ball|orb|light|up|led|ring|stand|magsafe|tech|accessory|accessories|merch|anime|gift|gifts|shop|for|with|and|the|a|an|iphone|pro|max|plus|mini|air|\d+)\b/g;
  function consume(text, phrase) {
    return text.replace(new RegExp('(^| )' + phrase + '(?= |$)', 'g'), ' ').replace(/\s+/g, ' ').trim();
  }
  function resolve(query) {
    var text = clean(query), rest = text, found = {};
    if (!text) return '';
    Object.keys(names).forEach(function (ip) {
      names[ip].slice().sort(function(a,b){return b.length-a.length;}).forEach(function (name) {
        var next = consume(rest, name);
        if (next !== rest) { found[ip] = true; rest = next; }
      });
    });
    var ips = Object.keys(found);
    if (ips.length !== 1) return '';
    var ip = ips[0];
    ambiguous[ip].forEach(function(name){rest = consume(rest, name);});
    // Unknown or conflicting fandom tokens are not a license to infer an IP.
    if (rest.replace(generic, ' ').trim()) return '';
    return ip;
  }
  function handle(product) {
    if (product.handle) return product.handle;
    try {
      var url = new URL(product.url || product.href, location.origin);
      if (url.origin !== location.origin) return '';
      var match = url.pathname.match(/\/products\/([^/]+)\/?$/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (e) { return ''; }
  }
  // Same greedy aliases as server Liquid; explicit role queries never use another role's image.
  function roleClean(value) { return String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9\u3400-\u9fff]+/g,' ').replace(/\s+/g,' ').trim(); }
  function resolveRole(query) {
    var rest=' '+roleClean(query)+' ', role='', ip='', bad=/ (?:not|without|exclude) /.test(rest);
    (imageConfig.queryAliases || []).forEach(function(pair){
      var token=' '+pair[0]+' ', key=pair[1]; if(rest.indexOf(token)===-1) return;
      rest=rest.split(token).join(' ');
      if(key==='__ambiguous__') bad=true;
      else if(key.indexOf('ip:')===0) { if(ip && ip!==key) bad=true; ip=key; }
      else { if(role && role!==key) bad=true; role=key; }
    });
    (imageConfig.queryGeneric || []).forEach(function(word){rest=rest.split(' '+word+' ').join(' ');});
    if(rest.trim().split(/\s+/).some(function(word){return word && !/^\d+$/.test(word);})) bad=true;
    if(!role && !ip) return bad ? {ambiguous:true} : null;
    var key=role || ip, context=(imageConfig.contexts || {})[key];
    if(!context) return {ambiguous:true};
    if(role && ip && context.ips.indexOf(ip.slice(3))===-1) bad=true;
    if(context.requireIP) {if(!ip) bad=true; else key=key+'@'+ip.slice(3);}
    if(bad) return {ambiguous:true};
    return {key:key,ip:ip ? ip.slice(3) : context.ips[0] || '',label:context.label,type:context.type};
  }
  function pick(product, query) {
    var context=resolveRole(query), entry=(imageConfig.roleProducts || {})[handle(product)];
    if(!context || context.ambiguous || context.type!=='role') return null;
    if(context && entry && (!product.id || String(product.id)===String(entry.id))) {
      var image=entry.roles && entry.roles[context.key];
      if(image) return {ip:context.ip,role:context.key,url:image.url,alt:entry.title+' — '+context.label+' design'};
    }
    // No IP-only, inferred or legacy cross-role image fallback.
    return null;
  }

  function resized(url, width) {
    var u = new URL(url, location.origin); u.searchParams.set('width', width); return u.href;
  }
  function restore(img, state) {
    ['srcset','sizes','alt'].forEach(function(k){
      if (state[k] === null) img.removeAttribute(k); else img.setAttribute(k,state[k]);
    });
    img.setAttribute('src',state.src);
    img.removeAttribute('data-search-image-ip');
    img.removeAttribute('data-search-image-role');
    img.removeAttribute('data-search-image-key');
  }
  function applyImage(img, choice, thumbnail, original) {
    if (!img) return;
    var state = saved.get(img);
    if (!state) {
      state = {src:img.getAttribute('src'),srcset:img.getAttribute('srcset'),sizes:img.getAttribute('sizes'),alt:img.getAttribute('alt')};
      if (original && img.hasAttribute('data-search-image-role')) { state.src=original; state.srcset=null; state.alt=img.getAttribute('data-search-original-alt') || state.alt; }
      saved.set(img,state);
    }
    if (!choice) { if (img.hasAttribute('data-search-image-ip') || img.hasAttribute('data-search-image-role')) restore(img,state); return; }
    if (failures.get(img) === choice.url) return;
    var choiceKey=(choice.role || choice.ip)+':'+choice.url;
    if (img.getAttribute('data-search-image-key') === choiceKey) return;
    img.setAttribute('data-search-image-key',choiceKey);
    if (choice.role) img.setAttribute('data-search-image-role',choice.role); else img.removeAttribute('data-search-image-role');
    img.setAttribute('data-search-image-ip',choice.ip);
    img.setAttribute('alt',choice.alt);
    var src = resized(choice.url,thumbnail ? 120 : 600);
    if (thumbnail) img.removeAttribute('srcset');
    else img.setAttribute('srcset',resized(choice.url,300)+' 300w, '+src+' 600w');
    img.onerror = function () {
      if (img.getAttribute('data-search-image-key') !== choiceKey) return;
      img.onerror = null; failures.set(img,choice.url); restore(img,state);
    };
    img.setAttribute('src',src);
  }
  function applyCards(root, query) {
    root.querySelectorAll('[data-product-card]').forEach(function(card){
      // Recently viewed must reflect product/history imagery, not the current search.
      if (card.closest('[data-od-history]')) return;
      applyImage(card.querySelector('.product-card-img'),pick({handle:card.dataset.handle,id:card.dataset.productId,url:card.dataset.url},query),false,card.dataset.image);
    });
  }
  function watch(root, query) {
    applyCards(root,query);
    if (root.hasAttribute('data-search-images-watched')) return;
    root.setAttribute('data-search-images-watched','');
    var queued = false;
    new MutationObserver(function(records){
      if (queued || !records.some(function(r){return r.addedNodes.length;})) return;
      queued = true;
      Promise.resolve().then(function(){queued=false;applyCards(root,query);});
    }).observe(root,{childList:true,subtree:true});
  }
  function predictive(root, query) {
    root.querySelectorAll('[data-predictive-product]').forEach(function(link){
      applyImage(link.querySelector('img'),pick({id:link.dataset.predictiveProduct,url:link.href},query),true);
    });
  }
  window.OddSearchImages = {resolve:resolve,resolveRole:resolveRole,pick:pick,watch:watch,predictive:predictive,applyCards:applyCards};
})();
